export default {
  jobsRecurring: [],
  jobsBus: [],
  jobs: [],
};
